import { SHUFFLE_QUOTES } from '../constants/actions';
// Data
import QUOTES from '../../data/quotes.json';
// Libraries
import shuffle from '../libs/shuffle';

export default function shuffleQuotes(state = [], action) {
  switch (action.type) {
    case SHUFFLE_QUOTES:
      return Object.assign({}, state, shuffle(QUOTES));
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/reducer-quotes.js
 **/